import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
// import styledComp from 'components/StyledComp';
import DataTables from 'components-desktop/DataTables';

const propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  changeHistories: PropTypes.array,
};

const defaultProps = {
  title: 'Change Histories',
  color: 'yellow_gold',
  changeHistories: [],
};

@autobind
class TableChangeHistories extends BaseComponent {
  constructor(props) {
    super(props);
  }

  createColumns() {
    return [{
      title: 'Id',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: 'descend',
    }, {
      title: 'Change Time',
      dataIndex: 'timeUsString',
      sorter: (a, b) => a.time - b.time,
    }, {
      title: 'Changed by User',
      dataIndex: 'userName',
      sorter: (a, b) => a.userName?.localeCompare(b.userName),
    }, {
      title: 'Type',
      dataIndex: 'type',
      sorter: (a, b) => a.type?.localeCompare(b.type),
    }, {
      title: 'Change Target',
      dataIndex: 'table',
      sorter: (a, b) => a.table?.localeCompare(b.table),
    }, {
      title: 'Change Target Id',
      dataIndex: 'rowId',
      sorter: (a, b) => a.rowId - b.rowId,
    }, {
      title: 'Change Field',
      dataIndex: 'field',
      sorter: (a, b) => a.field?.localeCompare(b.field),
    }, {
      title: 'Old Value',
      dataIndex: 'oldValue',
      sorter: (a, b) => a.oldValue?.localeCompare(b.oldValue),
    }, {
      title: 'New Value',
      dataIndex: 'newValue',
      sorter: (a, b) => a.newValue?.localeCompare(b.newValue),
    }];
  }

  createDataSource(changeHistories) {
    const dataSource = [];
    changeHistories?.forEach((changeHistory, index) => {
      dataSource.push({
        key: changeHistory.getId(),
        id: changeHistory.getId(),
        time: changeHistory.getLong('time'),
        timeUsString: changeHistory.getString('timeUsString'),
        userName: changeHistory.getString('userName'),
        type: changeHistory.getString('type'),
        table: changeHistory.getString('table'),
        rowId: changeHistory.getLong('rowId'),
        field: changeHistory.getString('field'),
        oldValue: changeHistory.getString('oldValue'),
        newValue: changeHistory.getString('newValue'),
      });
    });
    return dataSource;
  }

  renderContent() {
    const { changeHistories, title, color, ...layoutProps } = this.props;

    return (
      <DataTables
        {...layoutProps}
        ref={(ref) => { this.dataTables = ref; }}
        color={color}
        fontSize="12px"
        size="small"
        title={title}
        icon="clock-circle"
        withColumnFilter={false}
        columns={this.createColumns()}
        dataSource={this.createDataSource(changeHistories)}
      />
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
TableChangeHistories.propTypes = propTypes;
TableChangeHistories.defaultProps = defaultProps;

export default TableChangeHistories;
